// Shared presentational building blocks for the concession views.
import React from 'react';
import Icon from '../../../components/atoms/Icon';
import Hint from './Hint';
import '../concession.css';

export const Panel = ({ className = '', style, children }) => (
  <div className={`panel-2 cx-panel ${className}`} style={style}>
    {children}
  </div>
);

export const PanelHeader = ({ title, subtitle, info, actions }) => (
  <div className="cx-panel-header">
    <div style={{ minWidth: 0 }}>
      <div className="cx-panel-title-row">
        <h2 className="cx-panel-title">{title}</h2>
        {info && <InfoTip text={info} title={title} />}
      </div>
      {subtitle && <p className="cx-panel-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="cx-panel-actions">{actions}</div>}
  </div>
);

// Info icon + hint card. `title` names what's being explained.
export const InfoTip = ({ text, title }) => <Hint title={title} text={text} />;

export const GroupLabel = ({ children, info }) => (
  <div className="cx-group-label">
    {children}
    {info && <InfoTip text={info} title={children} />}
  </div>
);

// A single KPI. `meta` is a small note shown top-right (e.g. the time a peak occurred), `caption` a line under the value.
export const StatTile = ({ label, value, meta, caption, size = 'md', accent }) => (
  <div className={`cx-stat cx-stat-${size}`}>
    <div className="cx-stat-top">
      <span className="cx-stat-label">{label}</span>
      {meta && (
        <span className="cx-stat-meta">
          <Icon name="clock" />
          {meta}
        </span>
      )}
    </div>
    <div className="cx-stat-value" style={accent ? { color: accent } : undefined}>
      {value}
    </div>
    {caption && <div className="cx-stat-caption">{caption}</div>}
  </div>
);

// Sort dropdown. Open state is owned by the controller.
export const SortMenu = ({ isOpen, onToggle, options, current, onChange, formatLabel = (l) => l, minWidth = 260 }) => (
  <div className="cx-sort" style={{ position: 'relative' }}>
    <button type="button" className="cx-sort-btn" onClick={onToggle} aria-expanded={isOpen}>
      <Icon name="sort-down" />
      <span>{formatLabel(current.label)}</span>
      <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} className="cx-sort-caret" />
    </button>
    {isOpen && (
      <div className="cx-sort-menu" style={{ minWidth }}>
        {options.map((option) => {
          const selected = current.value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              className={`cx-sort-item ${selected ? 'selected' : ''}`}
              onClick={(e) => (selected ? onToggle(e) : onChange(option))}
            >
              <span>{formatLabel(option.label)}</span>
              {selected && <Icon name="check2" />}
            </button>
          );
        })}
      </div>
    )}
  </div>
);
